// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'




import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'
import 'normalize.css/normalize.css'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'



import ElementUI from 'element-ui'


//import './styles/index.css'
Vue.use(ElementUI)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js